<template>
  <div
    v-if="isPerksVisible"
  >
    <h4 class="values-title margin-bottom-xs">
      {{ title }}
    </h4>
    <ShopMoreFacade
      v-if="isMcom && isShopMoreExpandedEnabled"
      class="margin-bottom-xxs"
    />
    <Pzo v-if="showPzo" />
    <PromotionPerk
      v-if="isPromotionsVisible"
    />
    <Ppc
      v-if="isPpcVisible"
      :is-perks-placement="isBcom && isPpcVisible"
      class="margin-bottom-xxs perks-ppc"
    />
    <div v-if="selectedPrice.flags.creditFinance">
      <CcfpPerk v-if="isCcfp" />
      <KlarnaPerk
        v-if="isKlarnaVisible"
      />
    </div>
  </div>
</template>
<script setup>
/* istanbul ignore file */
import { computed } from 'vue';

import useKlarna from '@common-vue/media-card-large/src/modules/credit-finance/composables/useKlarna';
import useCcfp from '@common-vue/media-card-large/src/modules/credit-finance/composables/useCcfp';

import { useBrand } from '@composables/useBrand';
import { useExperiments } from '@composables/useExperiments';

import { Pzo, usePzo } from '@modules/pzo';
import { Ppc, usePpc } from '@modules/ppc';
import { ShopMoreFacade } from '@modules/shop-more';
import { useProductPrice } from '@modules/price';

import PromotionPerk from './PromotionPerk';
import CcfpPerk from './CcfpPerk';
import KlarnaPerk from './KlarnaPerk';

const selectedPrice = useProductPrice();

const { isMcom, isBcom } = useBrand();
const { showPzo } = usePzo();
const { isShowPpc, isBaseTier } = usePpc();
const { priceWithinRange } = useKlarna(selectedPrice);
const { isCcfp } = useCcfp(selectedPrice);
const {
  experimentFlags: {
    isShopMoreExpandedEnabled,
  },
} = useExperiments();

const title = isMcom ? 'More to love' : 'Offers & Perks';

const isPpcVisible = computed(() => (isMcom && isShowPpc.value) || (isBcom
    && isShowPpc.value
    && ((!selectedPrice.value?.offersData?.topOffer.isLoyallistOffer && selectedPrice.value?.offersData?.topOffer?.description)
        || isBaseTier.value)));
const isKlarnaVisible = computed(() => selectedPrice.value.flags.klarna && priceWithinRange.value);
const isPromotionsVisible = computed(() => selectedPrice.value.perksPromotions?.length > 0);
const isPerksVisible = computed(() => (showPzo || isPpcVisible.value || isPromotionsVisible.value || isKlarnaVisible.value || isCcfp)
        && (isMcom || (isBcom && !selectedPrice.value?.flags?.showOffersAvailableMessage)));
</script>

<style lang="scss" brand="bcom" scoped>
@import "~settingSCSS";

.perks-ppc {
  :deep(.loyalty-wrapper) {
    width: 100%;
    @include padding-direction('vertical', map-get($spacer, 'xs'));
  }
}
</style>
